module.exports = __webpack_public_path__ + "img/close-button.0ab5101c.png";